module.exports = __webpack_public_path__ + "img/sign-out.89bec3cb.svg";